import React, { useState } from 'react'
import {
  Card,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Upload
} from 'antd'
import { CloseCircleFilled } from '@ant-design/icons'
import _, { isEmpty, isUndefined, remove, some } from 'lodash'
import axios from 'axios'
import { useDeepEffect } from '../../../utils/hooks'
import styled from 'styled-components'
import SuccessIcon from '../../../assets/icons/success.png'
import SuccessDuplicateIcon from '../../../assets/icons/success_duplicate.png'
import AddIcon from '../../../assets/icons/Add_image.png'
import AddBinIcon from '../../../assets/icons/bin_1.png'
import { RESPONSE_MESSAGE } from '../../../utils/constants'
import { ButtonEx, Text } from '../../../shared.style'
import DetailSelection from '../../../components/DetailSelection'
import {
  compressFile,
  getPlaceholderDetail,
  getPlaceholderName
} from '../../../utils'

export const CircularBinImg = styled.div`
  cursor: pointer;
  ${(props) =>
    props.active &&
    `
      opacity: 0.5;
    `}
`

export const SuccessIconImg = styled.img`
  width: 16px;
  height: 16px;
  z-index: 2;
  position: absolute;
  left: 60%;
`

export const ButtonUploadDiv = styled.div`
  cursor: pointer;
`

const AddBin = (props) => {
  const { beforeUpload, setPage, formData, circularBinMaterials, categories } =
    props
  const [form] = Form.useForm()
  const [materialBinList, setMaterialBinList] = useState([])
  const [fileList, setFileList] = useState([])
  const [detailKey, setDetailKey] = useState(null)
  const [visible, setVisible] = useState(false)

  useDeepEffect(() => {
    form.setFieldsValue({
      bins: [
        {
          name: ''
        },
        {
          name: ''
        }
      ]
    })
    setMaterialBinList((prevState) => {
      const data = {
        id: 0,
        materialBins: []
      }
      prevState.push(data)
      return [...prevState]
    })
  }, [])

  const onClickItem = (circularBin, index) => {
    const isDuplicate = _.some(materialBinList, (material, idx) => {
      if (idx !== index) {
        return _.some(material.materialBins, (item) => {
          return item.id === circularBin.id
        })
      } else {
        return false
      }
    })

    if (!isDuplicate) {
      const findId = _.some(materialBinList, ['id', index])
      if (findId) {
        setMaterialBinList((prevState) => {
          prevState.forEach((state) => {
            if (state.id === index) {
              const findMaterial = _.some(state.materialBins, [
                'id',
                circularBin.id
              ])
              if (findMaterial) {
                _.remove(state.materialBins, ['id', circularBin.id])
              } else {
                state.materialBins.push(circularBin)
              }
            }
          })
          return [...prevState]
        })
      } else {
        const arr = []
        arr.push(circularBin)
        setMaterialBinList((prevState) => {
          const data = {
            id: index,
            materialBins: arr
          }
          prevState.push(data)
          return [...prevState]
        })
      }
    }
  }

  const renderItemActive = (item, index) => {
    let active = false
    materialBinList.forEach((bin) => {
      const isDuplicate = _.some(bin.materialBins, (material) => {
        return material.id === item.id
      })

      if (isDuplicate) {
        active = true
      } else {
        if (bin.id === index) {
          bin.materialBins.forEach((material) => {
            if (material.id === item.id) {
              active = true
            }
          })
        }
      }
    })

    return active
  }

  const renderSuccessActive = (item, index) => {
    let active = false
    materialBinList.forEach((bin, idx) => {
      if (idx !== 0) {
        const isDuplicate = _.some(bin.materialBins, (material) => {
          return material.id === item.id
        })

        if (isDuplicate) {
          active = idx !== index
        } else {
          if (bin.id === index) {
            bin.materialBins.forEach((material) => {
              if (material.id === item.id) {
                active = true
              }
            })
          }
        }
      }
    })
    return active ? SuccessDuplicateIcon : SuccessIcon
  }

  const onBack = () => {
    setPage('2')
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }

    return e && e.fileList
  }

  const handleBinChange = async (info, key) => {
    setFileList((prevState) => {
      const result = some(fileList, (item) => {
        return item.key === key
      })

      if (!result) {
        prevState.push({
          key: key,
          value: info.fileList[0]
        })
      } else {
        remove(fileList, (item) => {
          return item.key === key
        })
      }

      return [...prevState]
    })
  }

  const onFinish = async (values) => {
    const binRequestList = []
    for (const [, item] of values.bins.entries()) {
      const binData = {
        name: item.name,
        description: item.description || '',
        materialIdList: []
      }

      if (!isUndefined(item.image)) {
        const img = item.image[0]
        const formData = new FormData()
        formData.append('image', await compressFile(img.originFileObj))

        try {
          const res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
            formData,
            {
              headers: {
                'content-type': 'multipart/form-data'
              }
            }
          )

          const { data } = res
          binData.image = data.url
        } catch (err) {
          console.log(err)
        }

        binRequestList.push(binData)
      }
    }

    binRequestList.forEach((item, index) => {
      if (index !== 0) {
        for (const materialBin of materialBinList) {
          if (index === materialBin.id) {
            materialBin.materialBins.forEach((materialBinItem) => {
              item.materialIdList.push(materialBinItem.id)
            })
          }
        }
      }
    })

    const saveData = {
      ...formData,
      binRequestList
    }

    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/bin/createHeroBin`,
        saveData
      )
      message.success(RESPONSE_MESSAGE.SUCCESS)
      setPage('4')
    } catch (err) {
      const { response } = err
      const { data } = response
      Modal.error({
        content: `${data.message}`
      })
    }
  }

  const checkBinImg = (key) => {
    let bool

    if (isEmpty(fileList)) {
      bool = true
    } else {
      const result = some(fileList, (item) => {
        return item.key === key
      })
      bool = !result
    }

    return bool
  }

  const openModal = (key) => {
    setVisible(true)
    setDetailKey(key)
  }

  const onOk = () => {
    setVisible(false)
    setDetailKey(null)
  }

  const onCancel = () => {
    setVisible(false)
    setDetailKey(null)
  }

  return (
    <Form form={form} onFinish={onFinish} labelCol={{ span: 6 }}>
      <Form.List name="bins">
        {(fields, { add, remove }) => (
          <div>
            {fields.map(({ key, name, fieldKey, ...restField }, index) => (
              <Card
                key={key}
                style={{
                  marginBottom: 5,
                  backgroundColor: index === 0 ? '#ededed' : 'white'
                }}>
                <Row gutter={8} style={{ marginBottom: 10 }}>
                  <Col span={16}>
                    {key === 0 ? (
                      <span style={{ color: '#6ebf4b' }}>{`ถังขยะที่ ${
                        index + 1
                      } สำหรับใส่วัสดุที่ไม่มีถังอื่นรองรับ`}</span>
                    ) : (
                      <span style={{ color: '#6ebf4b' }}>{`ถังขยะที่ ${
                        index + 1
                      }`}</span>
                    )}
                  </Col>
                  <Col span={8}>
                    <Row justify="end">
                      {index !== 0 && index !== 1 && (
                        <CloseCircleFilled onClick={() => remove(name)} />
                      )}
                    </Row>
                  </Col>
                </Row>
                <Form.Item
                  {...restField}
                  name={[name, 'image']}
                  fieldKey={[fieldKey, 'image']}
                  label="รูปภาพถังขยะ"
                  rules={[
                    {
                      required: true,
                      message: 'เลือกรูปภาพถังขยะ'
                    }
                  ]}
                  valuePropName="fileList"
                  getValueFromEvent={normFile}>
                  <Upload
                    maxCount={1}
                    name="binImg"
                    fileList={[fileList[fieldKey]]}
                    listType="picture"
                    beforeUpload={beforeUpload}
                    onChange={(info) => handleBinChange(info, fieldKey)}>
                    {checkBinImg(fieldKey) && (
                      <ButtonUploadDiv>
                        <img src={AddIcon} alt="" width={80} height={80} />
                      </ButtonUploadDiv>
                    )}
                  </Upload>
                </Form.Item>
                <Form.Item
                  {...restField}
                  label="ชื่อถังขยะ"
                  name={[name, 'name']}
                  fieldKey={[fieldKey, 'name']}
                  rules={[{ required: true, message: 'กรอกชื่อถังขยะ' }]}>
                  <Input placeholder={getPlaceholderName(index)} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  label="คำอธิบายก่อนทิ้ง"
                  name={[name, 'description']}
                  fieldKey={[fieldKey, 'description']}>
                  <Input.TextArea
                    rows={2}
                    placeholder={getPlaceholderDetail(index)}
                  />
                </Form.Item>
                {key !== 0 && (
                  <div>
                    <Row>
                      <Space size="small">
                        <span style={{ color: 'red' }}>*</span>
                        <span>เลือกวัสดุที่ถังรองรับ</span>
                      </Space>
                    </Row>
                    <Row gutter={8}>
                      {circularBinMaterials.map((item, idx) => {
                        return (
                          <Col span={6} key={idx}>
                            {renderItemActive(item, index) && (
                              <SuccessIconImg
                                src={renderSuccessActive(item, index)}
                                alt=""
                              />
                            )}
                            <CircularBinImg
                              active={renderItemActive(item, index)}
                              onClick={() => onClickItem(item, index)}>
                              <Row justify="center">
                                <img
                                  style={{ borderRadius: '50%' }}
                                  src={item.image}
                                  alt=""
                                  width={64}
                                  height={64}
                                />
                              </Row>
                              <Row justify="center">
                                <span
                                  style={{ fontSize: 14, textAlign: 'center' }}>
                                  {item.name}
                                </span>
                              </Row>
                            </CircularBinImg>
                          </Col>
                        )
                      })}
                    </Row>
                    <Row justify="center" gutter={8}>
                      <Col>
                        <Text>หรือ</Text>
                      </Col>
                      <Col>
                        <Text
                          color="#6ebf4b"
                          cursor="pointer"
                          bold
                          onClick={() => openModal(fieldKey)}>
                          เลือกอย่างละเอียด
                        </Text>
                      </Col>
                    </Row>
                  </div>
                )}
              </Card>
            ))}
            <Card>
              <Form.Item>
                <ButtonUploadDiv onClick={() => add()}>
                  <Row justify="center">
                    <img src={AddBinIcon} alt="" width={80} height={80} />
                  </Row>
                  <Row type="flex" justify="center">
                    <span>เพิ่มถังขยะของ Circular Bin</span>
                  </Row>
                </ButtonUploadDiv>
              </Form.Item>
            </Card>
          </div>
        )}
      </Form.List>
      <Row justify="center" style={{ marginTop: 15 }}>
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => onBack()}>
            ย้อนกลับ
          </ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึกข้อมูล
          </ButtonEx>
        </Space>
      </Row>
      <DetailSelection
        materialBinList={materialBinList}
        detailKey={detailKey}
        onClickItem={onClickItem}
        onOk={onOk}
        visible={visible}
        categories={categories}
        onCancel={onCancel}
      />
    </Form>
  )
}

export default AddBin



// WEBPACK FOOTER //
// ./src/pages/SignupBin/AddBin/index.js